import gql from 'graphql-tag';

export const addCodProdTiendaGql = gql`
   mutation addCodProdTienda($shopCodProd: String!, $idProdVerPres: String!) {
      agregarCodProdTienda(shopCodProd: $shopCodProd, idProdVerPres: $idProdVerPres){
         shopCodProd
         idProdVerPres
      }
   }
`;

export const deleteCodProdTiendaGql = gql`
   mutation deleteCodProdTienda($shopCodProd: String!, $idProdVerPres: String!) {
      deleteCodProdTienda (shopCodProd: $shopCodProd, idProdVerPres: $idProdVerPres){
         shopCodProd
         idProdVerPres
      }
   }
`;

export const getCodProdTiendaGql = gql`
   query codProdTiendaFiltro($shopCodProd: String, $idProdVerPres: String) {
      codProdTiendaFiltro(shopCodProd: $shopCodProd, idProdVerPres: $idProdVerPres){
         shopCodProd
         idProdVerPres
      }
   }
`;
